import { State } from '@cemex/cmx-client-layout';
import { FiltersState } from '../store/reducer';

export const globalFiltersStateKey = 'globalFilters';

export interface GlobalFiltersState extends State {
  [globalFiltersStateKey]: FiltersState;
}
